import axios, { type AxiosResponse } from "axios";
import { ShippingItemSchema } from "@/schemas/index";
import type { ShippingItemType } from "@/schemas/index";
import env from "@/app/config/env";

export interface ServiceShippingApi {
  fetchShippingItem: (
    shippingId: ShippingItemType["Id"],
  ) => Promise<ShippingItemType>;
}

export const serviceShippingApi: ServiceShippingApi = {
  fetchShippingItem: (shippingId) => {
    return axios
      .get(`${env.services.portal}/shipping/${shippingId}`)
      .then((response: AxiosResponse<unknown>) => {
        return ShippingItemSchema.parse(response?.data);
      });
  },
};
